/* phq-gallery-colorfilter stage2 MAIN-LIVE 1789673547 */
(function(){
  function isPackSizeLabel(label){
    return /\d[\d\s-]*pack/i.test(label||'') || /^pack\s*size$/i.test((label||'').trim());
  }
  function selectedColorValue(){
    var fieldsets=document.querySelectorAll('variant-picker fieldset, .variant-picker fieldset, form[action*="/cart/add"] fieldset');
    for(var i=0;i<fieldsets.length;i++){
      var legend=fieldsets[i].querySelector('legend');
      var lt=((legend&&legend.textContent)||'').replace(/\s+/g,' ').trim().toLowerCase();
      if(lt.indexOf('color')===-1 && lt.indexOf('finish')===-1 && lt.indexOf('style')===-1) continue;
      var checked=fieldsets[i].querySelector('input[type=radio]:checked');
      if(!checked) continue;
      var v=(checked.value||'').trim();
      if(v && !isPackSizeLabel(v)) return v;
    }
    var map=loadMediaMap();
    var colorSet=map && map.colors ? map.colors : [];
    var checkedAll=document.querySelectorAll('variant-picker input[type=radio]:checked, .variant-picker input[type=radio]:checked, form[action*="/cart/add"] input[type=radio]:checked');
    for(var j=0;j<checkedAll.length;j++){
      var v2=(checkedAll[j].value||'').trim();
      if(!v2 || isPackSizeLabel(v2)) continue;
      if(colorSet.length && colorSet.indexOf(v2)!==-1) return v2;
    }
    for(var k=0;k<checkedAll.length;k++){
      var v3=(checkedAll[k].value||'').trim();
      if(v3 && !isPackSizeLabel(v3) && /color|option1/i.test(checkedAll[k].name||'')) return v3;
    }
    return null;
  }
  function loadMediaMap(){
    var el=document.getElementById('mff-media-color-map');
    if(!el) return null;
    try { return JSON.parse(el.textContent); } catch(e){ return null; }
  }
  function filenameFromUrl(url){
    if(!url) return '';
    try {
      var path=(url.split('?')[0]||'');
      var parts=path.split('/');
      return (parts[parts.length-1]||'').toLowerCase();
    } catch(e){ return ''; }
  }
  function stemOf(url){
    return filenameFromUrl(url).replace(/\.[^.]+$/,'').replace(/_[0-9a-f]{8}-[0-9a-f]{4}.*/i,'').slice(0,40);
  }
  function getProductJson(){
    var el=document.querySelector('script[type="application/json"][data-product-json], script#ProductJson-product, script[data-product]');
    if(el){ try { return JSON.parse(el.textContent); } catch(e){} }
    var scripts=document.querySelectorAll('script[type="application/json"]');
    for(var i=0;i<scripts.length;i++){
      var t=(scripts[i].textContent||'').trim();
      if(t.indexOf('"variants"')!==-1 && t.indexOf('"featured_image"')!==-1){
        try { return JSON.parse(t); } catch(e){}
      }
    }
    return window.__mffProductJson || null;
  }
  function selectedVariantId(){
    var input=document.querySelector('form[action*="/cart/add"] input[name="id"], product-form input[name="id"], input[name="id"][form]');
    if(input && input.value) return String(input.value);
    try {
      var u=new URL(window.location.href);
      var v=u.searchParams.get('variant');
      if(v) return String(v);
    } catch(e){}
    return null;
  }
  function resolveVariant(product, variantId){
    if(!product || !product.variants) return null;
    var id=variantId ? String(variantId) : null;
    if(id){
      for(var i=0;i<product.variants.length;i++){
        if(String(product.variants[i].id)===id) return product.variants[i];
      }
    }
    var color=selectedColorValue();
    if(color){
      for(var j=0;j<product.variants.length;j++){
        var v=product.variants[j];
        var opt=v.option1 || (v.options && v.options[0]) || '';
        if(String(opt)===color) return v;
      }
    }
    return product.variants[0]||null;
  }
  function featuredFilename(variant){
    if(!variant) return '';
    var fi=variant.featured_image;
    var src='';
    if(typeof fi==='string') src=fi;
    else if(fi && fi.src) src=fi.src;
    else if(variant.featured_media && variant.featured_media.preview_image) src=variant.featured_media.preview_image.src||'';
    return filenameFromUrl(src);
  }
  function mediaMatchesExact(mediaId, color, sku, map){
    if(!map || !map.byId) return false;
    var entry=map.byId[String(mediaId)];
    if(!entry) return false;
    if(color && entry.color && entry.color === color) return true;
    if(sku && entry.sku && entry.sku === sku) return true;
    return false;
  }
  function setVisible(el, show){
    if(!el) return;
    el.hidden = !show;
    el.style.setProperty('display', show ? '' : 'none', 'important');
    if(show){
      el.style.removeProperty('display');
      el.hidden = false;
    }
  }
  function showAll(mediaItems, thumbs){
    mediaItems.forEach(function(el){ setVisible(el, true); });
    thumbs.forEach(function(el){ setVisible(el, true); });
  }
  function collectThumbs(gallery){
    return [].slice.call(gallery.querySelectorAll('.product-gallery__thumbnail'));
  }
  function mediaSrcBlob(el){
    var img=el && el.querySelector('img');
    if(!img) return '';
    return ((img.getAttribute('src')||'')+' '+(img.getAttribute('srcset')||'')+' '+(img.currentSrc||'')).toLowerCase();
  }
  function thumbMatchesVisibleMedia(thumb, visibleMedia){
    var img=thumb.querySelector('img');
    if(!img) return false;
    var tsrc=((img.getAttribute('src')||'')+' '+(img.currentSrc||'')).toLowerCase();
    var tstem=stemOf(img.getAttribute('src')||img.currentSrc||'');
    for(var i=0;i<visibleMedia.length;i++){
      var blob=mediaSrcBlob(visibleMedia[i]);
      if(!blob) continue;
      if(tstem && blob.indexOf(tstem)!==-1) return true;
      var mimg=visibleMedia[i].querySelector('img');
      var mstem=stemOf(mimg ? (mimg.getAttribute('src')||mimg.currentSrc||'') : '');
      if(mstem && tsrc.indexOf(mstem)!==-1) return true;
    }
    return false;
  }
  function applyThumbFilter(gallery, mediaItems, showFlags){
    var thumbs=collectThumbs(gallery);
    var visibleMedia=[];
    mediaItems.forEach(function(el, idx){
      if(showFlags[idx]) visibleMedia.push(el);
    });
    thumbs.forEach(function(el, idx){
      var show=false;
      var id=el.getAttribute('data-media-id');
      if(id){
        // rare path
        for(var i=0;i<mediaItems.length;i++){
          if(mediaItems[i].getAttribute('data-media-id')===id){ show=!!showFlags[i]; break; }
        }
      } else if(typeof showFlags[idx]==='boolean' && mediaItems.length===thumbs.length){
        // Prefer index when 1:1
        show=!!showFlags[idx];
      } else {
        show=thumbMatchesVisibleMedia(el, visibleMedia);
      }
      setVisible(el, show);
    });
    return thumbs;
  }
  function showOnlyFeatured(mediaItems, gallery, featFile){
    var firstMedia=null;
    var stem=featFile ? featFile.replace(/\.[^.]+$/,'').toLowerCase() : '';
    var showFlags=[];
    mediaItems.forEach(function(el, idx){
      var img=el.querySelector('img');
      var src=img ? (img.getAttribute('src')||img.getAttribute('data-src')||img.currentSrc||'') : '';
      var srcset=img ? (img.getAttribute('srcset')||'') : '';
      var fn=filenameFromUrl(src);
      var match=false;
      if(featFile && fn === featFile) match=true;
      else if(stem && fn && fn.replace(/\.[^.]+$/,'') === stem) match=true;
      else if(stem && srcset.toLowerCase().indexOf(stem)!==-1) match=true;
      setVisible(el, match);
      showFlags[idx]=match;
      if(match && !firstMedia) firstMedia=el;
    });
    applyThumbFilter(gallery, mediaItems, showFlags);
    return firstMedia;
  }
  function selectMedia(gallery, firstMedia){
    if(!firstMedia) return;
    try {
      var carousel = gallery.querySelector('media-carousel');
      var mid=firstMedia.getAttribute('data-media-id');
      if(carousel && typeof carousel.select === 'function'){
        carousel.select(mid);
      } else {
        firstMedia.scrollIntoView({inline:'center', block:'nearest'});
      }
      // Do NOT click thumbs — Impact re-shows all thumbs on thumb click.
      // Mark aria-current on matching thumb by index instead.
      var mediaItems=[].slice.call(gallery.querySelectorAll('.product-gallery__media[data-media-id]'));
      var thumbs=collectThumbs(gallery);
      var idx=mediaItems.indexOf(firstMedia);
      thumbs.forEach(function(t, i){
        if(i===idx) t.setAttribute('aria-current','true');
        else t.setAttribute('aria-current','false');
      });
    } catch(e) {}
  }
  var _applying=false;
  function apply(){
    if(_applying) return;
    _applying=true;
    try {
      var color=selectedColorValue();
      var gallery=document.querySelector('product-gallery');
      if(!gallery) return;
      var mediaItems=[].slice.call(gallery.querySelectorAll('.product-gallery__media[data-media-id]'));
      var thumbs=collectThumbs(gallery);

      if(!color){
        showAll(mediaItems, thumbs);
        return;
      }

      var map=loadMediaMap();
      var product=getProductJson();
      var variant=resolveVariant(product, selectedVariantId());
      var sku=variant && variant.sku ? String(variant.sku) : '';
      var featFile=featuredFilename(variant);

      var firstMedia=null;
      var matchCount=0;
      var showFlags=[];
      mediaItems.forEach(function(el, idx){
        var id=el.getAttribute('data-media-id');
        var match=mediaMatchesExact(id, color, sku, map);
        setVisible(el, match);
        showFlags[idx]=match;
        if(match){ matchCount++; if(!firstMedia) firstMedia=el; }
      });
      applyThumbFilter(gallery, mediaItems, showFlags);

      if(matchCount===0){
        firstMedia=showOnlyFeatured(mediaItems, gallery, featFile);
        // rebuild flags after featured-only
        showFlags=mediaItems.map(function(el){ return !el.hidden && el.style.display!=='none'; });
      }

      // Modern Hooks only: the color filter's first match is the comparison graphic.
      // Open the big image on the variant featured lifestyle instead. Other products unchanged.
      if(product && product.handle==='modern-cast-iron-coat-hook-5-pack-color' && variant){
        var mffVid=String(variant.id);
        if(mffVid==='47145768583367' || mffVid==='47162351354055'){
          var mffNeedle=mffVid==='47145768583367' ? 'mff-antique-black-lifestyle-hat-tote' : 'mff-antique-bronze-lifestyle-hat-tote';
          mediaItems.forEach(function(el, idx){
            var img=el.querySelector('img');
            var blob=((img&&img.getAttribute('src'))||'')+' '+((img&&img.getAttribute('srcset'))||'');
            if(blob.toLowerCase().indexOf(mffNeedle)!==-1){
              setVisible(el, true);
              showFlags[idx]=true;
              firstMedia=el;
            }
          });
        }
      }

      if(product && product.handle==='cast-iron-animal-hooks-singles-style' && variant){
        var animalNeedle={
          '47162352304327':'mff-fox-lifestyle',
          '47162352402631':'mff-giraffe-lifestyle',
          '47162352337095':'mff-hare-lifestyle',
          '47145768386759':'mff-honey-bee-lifestyle',
          '47162352369863':'mff-moose-lifestyle',
          '47172874567879':'mff-owl-lifestyle'
        }[String(variant.id)];
        if(animalNeedle){
          mediaItems.forEach(function(el, idx){
            var img=el.querySelector('img');
            var blob=((img&&img.getAttribute('src'))||'')+' '+((img&&img.getAttribute('srcset'))||'');
            if(blob.toLowerCase().indexOf(animalNeedle)!==-1){
              setVisible(el, true);
              showFlags[idx]=true;
              firstMedia=el;
            }
          });
        }
      }

      selectMedia(gallery, firstMedia);
      if(product && product.handle==='modern-cast-iron-coat-hook-5-pack-color' && variant && firstMedia){
        var mffVid2=String(variant.id);
        if(mffVid2==='47145768583367' || mffVid2==='47162351354055'){
          var carousel=gallery.querySelector('media-carousel');
          var mffIdx=mediaItems.indexOf(firstMedia);
          if(carousel && typeof carousel.select==='function' && mffIdx>=0){
            try { carousel.select(mffIdx, {animate:false}); } catch(e){}
          }
        }
      }
      if(product && product.handle==='cast-iron-animal-hooks-singles-style' && variant && firstMedia){
        var animalIds={'47162352304327':1,'47162352402631':1,'47162352337095':1,'47145768386759':1,'47162352369863':1,'47172874567879':1};
        if(animalIds[String(variant.id)]){
          var carouselA=gallery.querySelector('media-carousel');
          var animalIdx=mediaItems.indexOf(firstMedia);
          if(carouselA && typeof carouselA.select==='function' && animalIdx>=0){
            try { carouselA.select(animalIdx, {animate:false}); } catch(e){}
          }
        }
      }
      // Impact may re-paint thumbs after select — re-apply thumb filter only
      var flagsCopy=showFlags.slice();
      setTimeout(function(){ applyThumbFilter(gallery, mediaItems, flagsCopy); }, 50);
      setTimeout(function(){ applyThumbFilter(gallery, mediaItems, flagsCopy); }, 300);
      setTimeout(function(){ applyThumbFilter(gallery, mediaItems, flagsCopy); }, 1000);
    } finally {
      _applying=false;
    }
  }
  function ensureProductJson(cb){
    if(window.__mffProductJson){ cb(); return; }
    var path=window.location.pathname;
    if(!/\/products\//.test(path)){ cb(); return; }
    var jsUrl=path.replace(/\/$/,'')+'.js';
    fetch(jsUrl).then(function(r){ return r.json(); }).then(function(j){
      window.__mffProductJson=j;
      cb();
    }).catch(function(){ cb(); });
  }
  var _applyTimer=null;
  function scheduleApply(){
    if(_applyTimer) clearTimeout(_applyTimer);
    _applyTimer=setTimeout(function(){ apply(); }, 40);
  }
  function boot(){
    ensureProductJson(function(){
      apply();
      setTimeout(apply, 300);
      setTimeout(apply, 1000);
    });
    document.addEventListener('change', function(e){
      if(e.target && e.target.matches && e.target.matches('input[type=radio], input[name="id"], select')) scheduleApply();
    });
    document.addEventListener('variant:change', scheduleApply);
    document.addEventListener('product:variant-change', scheduleApply);
    try {
      var gallery=document.querySelector('product-gallery');
      if(gallery){
        var mo=new MutationObserver(function(muts){
          var meaningful=muts.some(function(m){ return m.type==='childList' && (m.addedNodes.length||m.removedNodes.length); });
          if(meaningful) scheduleApply();
        });
        mo.observe(gallery, {childList:true, subtree:true});
      }
    } catch(e){}
  }
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
